import { render, staticRenderFns } from "./post-categories.vue?vue&type=template&id=4a8059d2&scoped=true&"
import script from "./post-categories.ts?vue&type=script&lang=ts&"
export * from "./post-categories.ts?vue&type=script&lang=ts&"
import style0 from "./post-categories.scss?vue&type=style&index=0&id=4a8059d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8059d2",
  null
  
)

export default component.exports